import { fetchItemSummariesIfNeeded, fetchItemSummaryIfNeeded } from '@/redux/modules/item/summary/itemSummary.actions';
import { fetchSimilarItemsGroups, getSimilarItemsGroupsItemIds } from '@/redux/modules/similarItemsGroups';
import { DataLoaderParams } from '@/types/DataLoaderParams';
import { getNotFoundUrl } from '@/utils/urls';

export default async ({ match: { params }, redirect, store }: DataLoaderParams<{ itemId: string }>) => {
    const { itemId: itemIdParam } = params;

    if (!itemIdParam) {
        return redirect(getNotFoundUrl());
    }

    const itemId = Number(itemIdParam);

    try {
        await store.dispatch(fetchItemSummaryIfNeeded({ identifier: 'SIMILAR-PAGE', itemId }));
    } catch {
        return redirect(getNotFoundUrl());
    }

    const item = store.getState().itemSummary.byId[itemId];
    if (!item) {
        return redirect(getNotFoundUrl());
    }

    await store.dispatch(fetchSimilarItemsGroups(itemId));

    const similarIds = getSimilarItemsGroupsItemIds(store.getState(), itemId);
    if (similarIds.length > 0) {
        await store.dispatch(
            fetchItemSummariesIfNeeded({
                identifier: 'SIMILAR-PAGE',
                itemIds: similarIds,
                similarItems: true,
            })
        );
    }

    return Promise.resolve();
};
